module.exports = __webpack_public_path__ + "img/lacava_brand_logo.9b73e5db.png";